import classNames from 'classnames'
import React, { forwardRef } from 'react'

import { ProductInformationProps } from './types'

const ProductInformation = forwardRef<HTMLDivElement, ProductInformationProps>(
  ({ className, children }, ref) => (
    <div
      ref={ref}
      className={classNames(className, 'px-6 md:px-10 xl:items-center')}
    >
      <div className="py-4 top-[calc(var(--header-height))] sticky w-full xl:flex xl:items-center xl:justify-center xl:min-h-[calc(100vh_-_var(--header-height-with-announcement))] xl:h-[min-content] xl:py-4">
        <div className="flex xl:items-center xl:min-h-[fit-content] w-full">
          <div className="w-full md:max-w-[400px] xl:max-w-[492px] mx-auto relative h-[auto]">
            {children}
          </div>
        </div>
      </div>
    </div>
  ),
)

export default ProductInformation
